module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/LA-Juvie-Yard2_BW-p-500-45b00c63055fc24e76a0e1cbea29d756.jpg";